import { TeamAccessEditDTO } from '../team/team-access-edit.dto';
import { IsNotEmpty, IsString, MaxLength, IsArray, MinLength } from 'class-validator';

export class WikiPostEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    title: string;

    @IsNotEmpty()
    @IsString()
    content: string;

    @IsNotEmpty()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    categories: Array<string>;

}
